import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  show() {
    if (!this.hasContentTarget) return;
    this.contentTarget.showPopover();
    this.position();
  }

  hide() {
    if (!this.hasContentTarget) return;
    this.contentTarget.hidePopover();
  }

  toggle() {
    if (!this.hasContentTarget) return;
    this.contentTarget.togglePopover();
    if (this.contentTarget.matches(":popover-open")) {
      this.position();
    }
  }

  position() {
    const triggerRect = this.element.getBoundingClientRect();
    const popover = this.contentTarget;
    const popoverRect = popover.getBoundingClientRect();
    const padding = 8;

    let top = triggerRect.bottom + window.scrollY + 8;
    let left = triggerRect.left + window.scrollX;
    let positionAbove = false;

    // Keep popover from going off the right edge
    if (left + popoverRect.width > window.innerWidth - padding) {
      left = window.innerWidth - popoverRect.width - padding;
    }

    // Keep popover from going off the left edge
    if (left < padding) {
      left = padding;
    }

    // If popover would go below viewport, show it above the trigger
    if (triggerRect.bottom + popoverRect.height > window.innerHeight - padding) {
      top = triggerRect.top + window.scrollY - popoverRect.height - 8;
      positionAbove = true;
    }

    popover.style.top = `${top}px`;
    popover.style.left = `${left}px`;

    // Set arrow position class
    popover.classList.toggle("popover-above", positionAbove);
    popover.classList.toggle("popover-below", !positionAbove);

    // Position arrow horizontally to point at trigger center
    const triggerCenter = triggerRect.left + triggerRect.width / 2;
    const arrowLeft = Math.max(12, Math.min(triggerCenter - left - 8, popoverRect.width - 28));
    popover.style.setProperty("--arrow-left", `${arrowLeft}px`);
  }

  // For hover behavior
  mouseEnter() {
    this.show();
  }

  mouseLeave() {
    this.hide();
  }
}
